import { useCallback, useState, type ReactNode } from "react";

import { type Conversation } from "shared/apiClient";

import { ShareDialog } from "./ShareDialog";

export interface ShareDialogContainerProps {
  children?: (openDialog: () => void) => ReactNode;
  conversation: Conversation | undefined | null;
}

export function ShareDialogContainer({
  children,
  conversation,
}: ShareDialogContainerProps) {
  const [sharedDialogOpen, setSharedDialogOpen] = useState(false);

  const openDialog = useCallback(() => {
    setSharedDialogOpen(true);
  }, []);

  return (
    <>
      {children?.(openDialog)}

      <ShareDialog
        conversation={conversation}
        open={sharedDialogOpen}
        onOpenChange={setSharedDialogOpen}
      />
    </>
  );
}
